import "./AboutPage.scss";

const AboutPage = () => {
  return <div>ABOUT US - page in construction</div>;
};

export default AboutPage;
